import { type ReactNode } from 'react';

import {
  createSectionStrategy,
  type DefinitionComponent,
  type DynamicComponent
} from '@dec/shared';

export const createSectionStrategyAdapter = (
  createComponent: (definition: DefinitionComponent) => ReactNode
) =>
  createSectionStrategy((definition) =>
    createComponent(definition as DefinitionComponent)
  ) as DynamicComponent;
